/**
 * Estilos inline que comunican la PROFUNDIDAD de un nodo en el árbol.
 *
 * El árbol del modelo llega a 4 niveles y, sin señales visuales, la relación
 * padre-hijo se pierde al desplazarse. Los estilos se calculan y no se declaran
 * en CSS porque el número de niveles no es fijo.
 */

/**
 * Calcula fondo, sombra, borde y sangría de un nodo según su nivel.
 *
 * Tres señales combinadas: el fondo aclara con la profundidad, la sangría crece
 * 24 px por nivel, y el borde izquierdo distingue los nodos con hijos de las
 * hojas.
 *
 * La claridad se topa en 98 % para que los niveles profundos no acaben en blanco
 * puro e ilegibles sobre fondo claro. A partir de ese tope, dos niveles
 * consecutivos se ven iguales: es el límite práctico de la señal por color, y
 * por eso la sangría —que no se topa— sigue diferenciándolos.
 *
 * @param nivel - Profundidad, base 1. La sangría de nivel 1 es 0.
 * @param tieneHijos - Si el nodo es rama (`true`) u hoja (`false`).
 * @returns Objeto de estilos listo para `:style` de Vue.
 *
 * @example
 * <div :style="estiloJerarquico(2, true)">Característica 1.1</div>
 */
export function estiloJerarquico(nivel: number, tieneHijos: boolean): Record<string, string> {
  const tonoBase = 210
  const claridad = Math.min(98, 85 + nivel * 10)
  return {
    backgroundColor: `hsl(${tonoBase}, 60%, ${claridad}%)`,
    boxShadow: tieneHijos
      ? '0 3px 8px rgba(0,0,0,0.18)'
      : '0 1px 4px rgba(0,0,0,0.10)',
    borderLeft: tieneHijos
      ? '5px solid #0e69a0'
      : '3px solid #8bb8d6',
    marginLeft: `${(nivel - 1) * 24}px`
  }
}
